"use client";

import { BSRFilter } from "./bsr/BSRFilter";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Filter as LegacyFilter } from "./legacy/Filter";

export const Filter = createBSRExperimentIcon(LegacyFilter, BSRFilter);
